import { MotionGlobalConfig } from "../utils/GlobalConfig.js";
import { frameData } from "./frame.js";
let now;
function clearTime() {
  now = void 0;
}
const time = {
  now: () => {
    if (now === void 0) {
      time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now());
    }
    return now;
  },
  set: (newTime) => {
    now = newTime;
    queueMicrotask(clearTime);
  }
};
export {
  time
};
//# sourceMappingURL=sync-time.js.map
